import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";
import { getSelectableMenuAccess } from "../../../constants/userMenuAccess";

const tipeUserOptions = [
  { value: "OWN/DIREKSI", label: "OWN/DIREKSI" },
  { value: "MGR", label: "MANAGER" },
  { value: "SPV", label: "SPV" },
  { value: "ADM", label: "ADMIN" },
  { value: "KOLEKTOR", label: "KOLEKTOR" },
  { value: "SUR", label: "SURVEYOR" },
  { value: "VERIFIKATOR", label: "VERIFIKATOR" },
  { value: "ADMIN VERIFIKATOR", label: "ADMIN VERIFIKATOR" },
];

const getTipeUserOptions = (activeTipeUser) => {
  if (activeTipeUser === "OWN/DIREKSI") {
    return tipeUserOptions;
  }

  if (activeTipeUser === "MGR" || activeTipeUser === "MANAGER") {
    return tipeUserOptions.slice(2);
  }

  if (
    activeTipeUser === "SPV" ||
    activeTipeUser === "SPV/KOMITE" ||
    activeTipeUser === "KOMITE/SPV"
  ) {
    return tipeUserOptions.slice(3);
  }

  if (activeTipeUser === "ADM" || activeTipeUser === "ADMIN") {
    return tipeUserOptions.slice(4);
  }

  return [];
};

const TambahUser = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const availableTipeUserOptions = getTipeUserOptions(user.tipeUser);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tipeUser, setTipeUser] = useState(
    availableTipeUserOptions[0]?.value || "",
  );
  const [kodeCabang, setKodeCabang] = useState(user.cabang?._id || "");
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [kodeKolektor, setKodeKolektor] = useState("");
  const [aksesSurveyor, setAksesSurveyor] = useState(false);
  const [aksesKolektor, setAksesKolektor] = useState(false);
  const [aksesNamaPemohon, setAksesNamaPemohon] = useState(false);
  const [aksesPermohonan, setAksesPermohonan] = useState(false);
  const [aksesAdmin, setAksesAdmin] = useState(false);
  const [aksesDataVerifikasi, setAksesDataVerifikasi] = useState(false);
  const [aksesValidasiDataVerifikator, setAksesValidasiDataVerifikator] = useState(false);
  const [aksesDaftarKunjungan, setAksesDaftarKunjungan] = useState(false);
  const [aksesProfilUser, setAksesProfilUser] = useState(true);
  const [aksesDaftarUser, setAksesDaftarUser] = useState(false);
  const [aksesSetting, setAksesSetting] = useState(false);

  const [cabangs, setCabangs] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [kolektors, setKolektors] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadOptions();
  }, []);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const loadOptions = async () => {
    setLoading(true);
    try {
      const payload = {
        id: user._id,
        token: user.token,
      };
      const cabangRes = await axios.post(`${tempUrl}/cabangs`, payload);
      const surveyorRes = await axios.post(`${tempUrl}/surveyorsAllCabang`, payload);
      const kolektorRes = await axios.post(`${tempUrl}/kolektorsAllCabang`, payload);

      setCabangs(cabangRes.data);
      setSurveyors(surveyorRes.data);
      setKolektors(kolektorRes.data);
    } catch (err) {
      handleAuthError(err);
    }
    setLoading(false);
  };

  const tipeUserHandler = (value) => {
    setTipeUser(value);
    if (value !== "SUR") setKodeSurveyor("");
    if (value !== "KOLEKTOR") setKodeKolektor("");
    setAksesSurveyor(false);
    setAksesKolektor(false);
    setAksesNamaPemohon(false);
    setAksesPermohonan(false);
    setAksesAdmin(false);
    setAksesDataVerifikasi(false);
    setAksesValidasiDataVerifikator(false);
    setAksesDaftarKunjungan(false);
    setAksesProfilUser(true);
    setAksesDaftarUser(false);
    setAksesSetting(false);
  };

  const selectableAccess = getSelectableMenuAccess(tipeUser);
  const accessValues = {
    surveyor: aksesSurveyor,
    kolektor: aksesKolektor,
    namaPemohon: aksesNamaPemohon,
    permohonan: aksesPermohonan,
    admin: aksesAdmin,
    dataVerifikasi: aksesDataVerifikasi,
    validasiDataVerifikator: aksesValidasiDataVerifikator,
    daftarKunjungan: aksesDaftarKunjungan,
    profilUser: aksesProfilUser,
    daftarUser: aksesDaftarUser,
    setting: aksesSetting,
  };
  const pilihSemuaAkses = selectableAccess.every((key) => accessValues[key]);

  const pilihSemuaAksesHandler = () => {
    const value = !pilihSemuaAkses;
    setAksesSurveyor(selectableAccess.includes("surveyor") && value);
    setAksesKolektor(selectableAccess.includes("kolektor") && value);
    setAksesNamaPemohon(selectableAccess.includes("namaPemohon") && value);
    setAksesPermohonan(selectableAccess.includes("permohonan") && value);
    setAksesAdmin(selectableAccess.includes("admin") && value);
    setAksesDataVerifikasi(selectableAccess.includes("dataVerifikasi") && value);
    setAksesValidasiDataVerifikator(selectableAccess.includes("validasiDataVerifikator") && value);
    setAksesDaftarKunjungan(selectableAccess.includes("daftarKunjungan") && value);
    setAksesProfilUser(selectableAccess.includes("profilUser") && value);
    setAksesDaftarUser(selectableAccess.includes("daftarUser") && value);
    setAksesSetting(selectableAccess.includes("setting") && value);
  };

  const saveUser = async (event) => {
    event.preventDefault();

    if (!username || !password || !tipeUser || !kodeCabang) {
      setError("Username, password, tipe user, dan cabang wajib diisi.");
      return;
    }

    if (tipeUser === "SUR" && !kodeSurveyor) {
      setError("Surveyor wajib dipilih untuk tipe user SUR.");
      return;
    }

    if (tipeUser === "KOLEKTOR" && !kodeKolektor) {
      setError("Kolektor wajib dipilih untuk tipe user KOLEKTOR.");
      return;
    }

    setLoading(true);
    try {
      const duplicate = await axios.post(`${tempUrl}/getUsername`, {
        username,
        id: user._id,
        token: user.token,
      });

      if (duplicate.data.length > 0) {
        setError("Username sudah digunakan.");
        setLoading(false);
        return;
      }

      await axios.post(`${tempUrl}/auth/register`, {
        username,
        password,
        tipeUser,
        kodeCabang,
        kodeSurveyor,
        kodeKolektor,
        akses: {
          surveyor: selectableAccess.includes("surveyor") && aksesSurveyor,
          kolektor: selectableAccess.includes("kolektor") && aksesKolektor,
          namaPemohon: selectableAccess.includes("namaPemohon") && aksesNamaPemohon,
          permohonan: selectableAccess.includes("permohonan") && aksesPermohonan,
          admin: selectableAccess.includes("admin") && aksesAdmin,
          dataVerifikasi: selectableAccess.includes("dataVerifikasi") && aksesDataVerifikasi,
          verifikator: selectableAccess.includes("dataVerifikasi") && aksesDataVerifikasi,
          validasiDataVerifikator:
            selectableAccess.includes("validasiDataVerifikator") && aksesValidasiDataVerifikator,
          adminVerifikator:
            selectableAccess.includes("validasiDataVerifikator") && aksesValidasiDataVerifikator,
          daftarKunjungan:
            selectableAccess.includes("daftarKunjungan") && aksesDaftarKunjungan,
          surveyKolektor:
            selectableAccess.includes("daftarKunjungan") && aksesDaftarKunjungan,
          profilUser: selectableAccess.includes("profilUser") && aksesProfilUser,
          daftarUser: selectableAccess.includes("daftarUser") && aksesDaftarUser,
          setting: selectableAccess.includes("setting") && aksesSetting,
        },
        id: user._id,
        token: user.token,
      });
      navigate("/daftarUser");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menyimpan user.");
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Utility</div>
          <h1 className="page-title">Tambah User</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveUser}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tipe User</Form.Label>
                <Form.Select
                  value={tipeUser}
                  disabled={availableTipeUserOptions.length === 0}
                  onChange={(e) => tipeUserHandler(e.target.value)}
                >
                  {availableTipeUserOptions.length === 0 && (
                    <option value="">TIDAK MEMILIKI AKSES MEMILIH TIPE USER</option>
                  )}
                  {availableTipeUserOptions.map((tipe) => (
                    <option key={tipe.value} value={tipe.value}>
                      {tipe.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cabang</Form.Label>
                <Form.Select value={kodeCabang} onChange={(e) => setKodeCabang(e.target.value)}>
                  <option value="">PILIH CABANG</option>
                  {cabangs.map((cabang) => (
                    <option key={cabang._id} value={cabang._id}>
                      {cabang._id} - {cabang.namaCabang}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          {tipeUser === "SUR" && (
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Surveyor</Form.Label>
                  <Form.Select value={kodeSurveyor} onChange={(e) => setKodeSurveyor(e.target.value)}>
                    <option value="">PILIH SURVEYOR</option>
                    {surveyors.map((surveyor) => (
                      <option key={surveyor._id} value={surveyor._id}>
                        {surveyor.kodeSurveyor} - {surveyor.namaSurveyor}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          )}
          {tipeUser === "KOLEKTOR" && (
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Kolektor</Form.Label>
                  <Form.Select value={kodeKolektor} onChange={(e) => setKodeKolektor(e.target.value)}>
                    <option value="">PILIH KOLEKTOR</option>
                    {kolektors.map((kolektor) => (
                      <option key={kolektor._id} value={kolektor._id}>
                        {kolektor.kodeKolektor} - {kolektor.namaKolektor}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          )}
          <h2 className="h6 fw-bold mt-4 mb-2">Hak Akses</h2>
          <Form.Check
            className="mb-2"
            type="checkbox"
            label="Pilih Semua"
            checked={pilihSemuaAkses}
            onChange={pilihSemuaAksesHandler}
          />
          <Row>
            <Col md={6}>
              {selectableAccess.includes("surveyor") && <Form.Check type="checkbox" label="Surveyor" checked={aksesSurveyor} onChange={() => setAksesSurveyor(!aksesSurveyor)} />}
              {selectableAccess.includes("kolektor") && <Form.Check type="checkbox" label="Kolektor" checked={aksesKolektor} onChange={() => setAksesKolektor(!aksesKolektor)} />}
              {selectableAccess.includes("permohonan") && <Form.Check type="checkbox" label="Entry Permohonan" checked={aksesPermohonan} onChange={() => setAksesPermohonan(!aksesPermohonan)} />}
              {selectableAccess.includes("namaPemohon") && <Form.Check type="checkbox" label="Daftar Permohonan" checked={aksesNamaPemohon} onChange={() => setAksesNamaPemohon(!aksesNamaPemohon)} />}
              {selectableAccess.includes("admin") && <Form.Check type="checkbox" label="Data Permohonan" checked={aksesAdmin} onChange={() => setAksesAdmin(!aksesAdmin)} />}
              {selectableAccess.includes("dataVerifikasi") && <Form.Check type="checkbox" label="Data Verifikasi" checked={aksesDataVerifikasi} onChange={() => setAksesDataVerifikasi(!aksesDataVerifikasi)} />}
              {selectableAccess.includes("validasiDataVerifikator") && <Form.Check type="checkbox" label="Validasi Data Verifikator" checked={aksesValidasiDataVerifikator} onChange={() => setAksesValidasiDataVerifikator(!aksesValidasiDataVerifikator)} />}
              {selectableAccess.includes("daftarKunjungan") && <Form.Check type="checkbox" label="Daftar Kunjungan" checked={aksesDaftarKunjungan} onChange={() => setAksesDaftarKunjungan(!aksesDaftarKunjungan)} />}
              {selectableAccess.includes("profilUser") && <Form.Check type="checkbox" label="Profil User" checked={aksesProfilUser} onChange={() => setAksesProfilUser(!aksesProfilUser)} />}
            </Col>
            <Col md={6}>
              {selectableAccess.includes("daftarUser") && <Form.Check type="checkbox" label="Daftar User" checked={aksesDaftarUser} onChange={() => setAksesDaftarUser(!aksesDaftarUser)} />}
              {selectableAccess.includes("setting") && <Form.Check type="checkbox" label="Setting" checked={aksesSetting} onChange={() => setAksesSetting(!aksesSetting)} />}
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate("/daftarUser")}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TambahUser;

